import { SessionType, type SessionTypeKey } from '@/stores/sessionType'

import type { BookingSessionBundle } from '@VelocitySquared/sunny16-content-dataobjects-cady/booking'

export { valueSessionBundlesListingFallback } from './basicBundles'
export { basicMaxBundleFallback } from './basicMaxCatalogBundle'
export { basicPlusBundleFallback } from './basicPlusCatalogBundle'
export { basicBundleFallback } from './basicSessionCatalogBundle'
export { essentialBundleFallback, miniBundleFallback } from './budgetBundleFallbacks'
export { budgetSessionBundlesListingFallback } from './budgetBundles'
export { bundleFeature } from './bundleFeature'
export { eliteBundleFallback } from './eliteCatalogBundle'
export { elitePlusBundleFallback } from './elitePlusCatalogBundle'
export { eliteUnlimitedBundleFallback } from './eliteUnlimitedCatalogBundle'
export { legacyBundleFallback } from './legacyCatalogBundle'
export { mostPopularBundleFallback } from './mostPopularCatalogBundle'
export { simpleBundleFallback } from './simpleCatalogBundle'
export { standardBundleFallback } from './standardCatalogBundle'
export { yearbookOnlyBundleFallback } from './yearbookOnlyCatalogBundle'

import { basicMaxBundleFallback } from './basicMaxCatalogBundle'
import { basicPlusBundleFallback } from './basicPlusCatalogBundle'
import { basicBundleFallback } from './basicSessionCatalogBundle'
import { essentialBundleFallback, miniBundleFallback } from './budgetBundleFallbacks'
import { eliteBundleFallback } from './eliteCatalogBundle'
import { elitePlusBundleFallback } from './elitePlusCatalogBundle'
import { eliteUnlimitedBundleFallback } from './eliteUnlimitedCatalogBundle'
import { legacyBundleFallback } from './legacyCatalogBundle'
import { mostPopularBundleFallback } from './mostPopularCatalogBundle'
import { simpleBundleFallback } from './simpleCatalogBundle'
import { standardBundleFallback } from './standardCatalogBundle'

/**
 * CMS-typed fallback content for session bundles, keyed by SessionTypeKey.
 *
 * RS+ siblings temporarily reuse their standard sibling's fallback so the
 * `catalogWithContent` loop surfaces the `*RoadshowPlus` bundles. Per RS+
 * ADR 2026.04.20-002 Pattern 5 (content registry Option A), each RS+ tier
 * should eventually get its own dedicated fallback file so RS+ copy can
 * diverge from studio copy.
 */
export const sessionBundleFallbacks: Partial<Record<SessionTypeKey, BookingSessionBundle>> = {
  [SessionType.EliteUnlimited]: eliteUnlimitedBundleFallback,
  [SessionType.ElitePlus]: elitePlusBundleFallback,
  [SessionType.Elite]: eliteBundleFallback,
  [SessionType.MostPopular]: mostPopularBundleFallback,
  [SessionType.Legacy]: legacyBundleFallback,
  // TODO RS+: replace with dedicated legacyRoadshowPlusBundleFallback when RS+ copy diverges
  [SessionType.LegacyRoadshowPlus]: legacyBundleFallback,
  [SessionType.Standard]: standardBundleFallback,
  // TODO RS+: replace with dedicated standardRoadshowPlusBundleFallback when RS+ copy diverges
  [SessionType.StandardRoadshowPlus]: standardBundleFallback,
  [SessionType.Simple]: simpleBundleFallback,
  // TODO RS+: replace with dedicated simpleRoadshowPlusBundleFallback when RS+ copy diverges
  [SessionType.SimpleRoadshowPlus]: simpleBundleFallback,
  [SessionType.BasicMax]: basicMaxBundleFallback,
  // TODO RS+: replace with dedicated basicMaxRoadshowPlusBundleFallback when RS+ copy diverges
  [SessionType.BasicMaxRoadshowPlus]: basicMaxBundleFallback,
  [SessionType.BasicPlus]: basicPlusBundleFallback,
  // TODO RS+: replace with dedicated basicPlusRoadshowPlusBundleFallback when RS+ copy diverges
  [SessionType.BasicPlusRoadshowPlus]: basicPlusBundleFallback,
  [SessionType.Basic]: basicBundleFallback,
  // TODO RS+: replace with dedicated basicRoadshowPlusBundleFallback when RS+ copy diverges
  [SessionType.BasicRoadshowPlus]: basicBundleFallback,
  [SessionType.Mini]: miniBundleFallback,
  // TODO RS+: replace with dedicated miniRoadshowPlusBundleFallback when RS+ copy diverges
  [SessionType.MiniRoadshowPlus]: miniBundleFallback,
  [SessionType.Essential]: essentialBundleFallback,
  // TODO RS+: replace with dedicated essentialRoadshowPlusBundleFallback when RS+ copy diverges
  [SessionType.EssentialRoadshowPlus]: essentialBundleFallback
}
